// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  editButtonHint: 'Edit value',
  okButtonHint: 'Save changes',
  cancelButtonHint: 'Discard changes'
};